/**
 * Pijl-navigatie voor de productcarrousel (uitgelichte producten).
 * Het swipen zelf is native scroll-snap; dit script stuurt alleen de
 * pijlknoppen aan en verbergt ze als er niets te scrollen valt.
 */
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

document.querySelectorAll('[data-product-slider]').forEach((slider) => {
  const track = slider.querySelector('[data-slider-track]');
  const prev = slider.querySelector('[data-slider-prev]');
  const next = slider.querySelector('[data-slider-next]');
  if (!track || !prev || !next) return;

  const update = () => {
    const maxScroll = track.scrollWidth - track.clientWidth;
    slider.classList.toggle('has-overflow', maxScroll > 8);
    prev.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft >= maxScroll - 4;
  };

  const step = () => {
    const card = track.querySelector('.product-card');
    if (!card) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  };

  const scrollByStep = (richting) => {
    track.scrollBy({
      left: richting * step(),
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
    });
  };

  prev.addEventListener('click', () => scrollByStep(-1));
  next.addEventListener('click', () => scrollByStep(1));
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
});
